import { Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import '../MajorProjectTimeline.less';
import SubjectBasicInfo from './componments/SubjectBasicInfo';
import ProjectBasicInfo from './componments/ProjectBasicInfo';
import UserLogs from './componments/UserLogs';
import { getDictType } from '@/services/common';
import { LGG_ACCOUNT_TYPE, LGG_MANAGER_TYPE } from '@/utils/mappingDict';
import { getGrainGrowerApplyDetail } from '@/services/largeGrainGrower';

const defaultParams = [LGG_ACCOUNT_TYPE, LGG_MANAGER_TYPE].join(',');
export default function LargeGrainGrowerTimeline() {
  const { search } = useLocation();
  const { id } = qs.parse(search);

  const { data: dict = {} } = useRequest(getDictType, { defaultParams: [defaultParams] });

  const { loading, data } = useRequest(() => getGrainGrowerApplyDetail(id));

  return (
    <Spin spinning={loading}>
      <SubjectBasicInfo data={data} dict={dict} />
      <ProjectBasicInfo data={data} />
      <UserLogs userLogs={data?.userLogs || []} />
    </Spin>
  );
}
